import { RootState } from '@debbie/cortex/dist/reducer.js'
import {
  ApiInsights,
  Content,
  PageBase,
  SubMenu,
  TopNav,
} from '@debbie/iris/dist/components/index.js'
import OrderedReport from '@debbie/iris/dist/components/Insights/OrderedReport.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import { useLocation, useRouteMatch } from 'react-router-dom'

import DefaultReporter from './DefaultReporter.js'

const Reports = () => {
  const lang = useSelector((s: RootState) => s.lang)
  const match = useRouteMatch()
  const location = useLocation()
  const selectedCreditor = useSelector((s: RootState) => s.selectedCreditor)

  const items = [
    {
      text: lang.navigation.reportsExorts,
      link: `${match.url}/downloads`,
    },
    {
      text: 'Power BI',
      link: `${match.url}/powerbi`,
    },
  ]

  return (
    <div>
      <TopNav />
      <Content>
        <PageBase>
          <SubMenu items={items} />
          <Switch location={location}>
            <div>
              <Route exact path="/reports/downloads">
                <DefaultReporter />
              </Route>
              <Route exact path="/reports/downloads/:id">
                <OrderedReport />
              </Route>
              <Route exact path="/reports/powerbi">
                <ApiInsights isClient={true} creditorId={selectedCreditor} />
              </Route>
            </div>
          </Switch>
        </PageBase>
      </Content>
    </div>
  )
}

export default Reports
